import React from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import getMediaUrl from "utils/getMediaUrl"
import HeroSection from "components/content/HomepageSection/HeroSection"
import VideoShowcase from "components/molecules/VideoShowcase"
import { Information } from "components/molecules/PublicInformation"
import SEO from "components/molecules/SEO"
import Layout from "components/molecules/Layout"

const IndexPage = ({
  data: {
    api: { newHomepage },
  },
  pageContext: { language },
}) => (
  <Layout language={language}>
    <SEO title="Home" />
    <HeroSection
      sectionData={{
        header: "Development, Executed.",
        description:
          "Exdev is a privately held commercial real estate development company working on mixed-use, hotel, industrial, retail and office projects in the United States.",
      }}
    />
    <Information id="homepage-about">
      <h2>Real estate development, from planning to operations</h2>
      <p>
        Our work includes planning, entitlement, development and asset
        management. Explore our company and the properties in our portfolio to
        learn about our development activity.
      </p>
      <p>
        <a href="/en/about">About Exdev</a>
        {" · "}
        <a href="/en/portfolio">Explore our portfolio</a>
      </p>
      <h2>Project information and reporting</h2>
      <p>
        These demonstrations illustrate tools for documenting project progress
        and viewing property information. They do not describe an investment
        offering.
      </p>
    </Information>
    <VideoShowcase
      videos={[
        {
          title: "Project reports",
          description: "An illustration of project reporting tools.",
          videoUrl: getMediaUrl(
            newHomepage.newTransparencySection.videoReports
          ),
        },
        {
          title: "Property information",
          description: "An illustration of property research tools.",
          videoUrl: getMediaUrl(
            newHomepage.digitalExperienceSection.videoRapidProspectingTools
          ),
        },
      ]}
    />
    <Information>
      <h2>Connect with our team</h2>
      <p>
        For general company, property or business enquiries,{" "}
        <a href="/en/contact">contact Exdev</a>.
      </p>
      <p>
        Existing investors can use their established{" "}
        <a href="https://investors.appfolioim.com/exdev/investor/login">
          investor portal
        </a>
        .
      </p>
    </Information>
  </Layout>
)
IndexPage.propTypes = {
  data: PropTypes.shape({
    api: PropTypes.shape({
      newHomepage: PropTypes.shape({
        newTransparencySection: PropTypes.shape({
          videoReports: PropTypes.string,
        }),
        digitalExperienceSection: PropTypes.shape({
          videoRapidProspectingTools: PropTypes.string,
        }),
      }),
    }),
  }).isRequired,
  pageContext: PropTypes.shape({ language: PropTypes.string }).isRequired,
}
export const query = graphql`
  query IndexPageData($apiLocale: API_Locale) {
    api {
      newHomepage(language: $apiLocale) {
        newTransparencySection {
          videoReports
        }
        digitalExperienceSection {
          videoRapidProspectingTools
        }
      }
    }
  }
`
export default IndexPage
